import axios from './_axios_config';

const customPath = (resource, ...params) => {
    const queryString = params.filter(param => param).join('&');
    return `/users/clients/${resource}${queryString ? `?${queryString}` : ''}`;
}

const processRequest = async (req) => {
    try {
        const { data, status } = await req

        if (status >= 200 && status < 300) {
            return {
                status: true,
                ...data
            }
        } else {
            throw {
                status: false,
                ...data
            }
        }

    } catch (error) {
        if (error.intercepted) {
            return {
                error: error.details,
                status: false,
                handled: true
            };
        }

        const details = error.response?.data?.details;
        const message = error.response?.data?.message;

        if (message) {
            if (message.includes("invalid code")) {
                return {
                    error: "Código de verificação incorreto",
                    status: false,
                    handled: true,
                    original: error
                };
            }

            if (message.includes("enterprise registered in the system")) {
                return {
                    error: "Empresa já cadastrada no sistema",
                    status: false,
                    handled: true,
                    original: error
                };
            }

            if (message.includes("no code generated")) {
                return {
                    error: "Código expirado ou não gerado para esse cadastro",
                    status: false,
                    handled: true,
                    original: error
                };
            }

            if (message.includes("this hash is not valid")) {
                return {
                    error: "Link de redefinição expirado, tente novamente!",
                    status: false,
                    handled: true,
                    original: error
                };
            }

        }

        if (details) {
            if (details.includes("recovery password has already been sent to this email")) {
                return {
                    error: "Um link de redefinição de senha já foi enviado para o seu e-mail",
                    status: false,
                    handled: true,
                    original: error
                };
            }
        }

        if (error.status) {
            switch (error.status) {
                case 409:
                    return {
                        error: "Aparentemente este cadastro já existe no sistema",
                        status: false,
                        handled: true
                    }
                case 401:
                    return {
                        error: "E-mail ou senha estão incorretos",
                        status: false,
                        handled: true
                    }
                default:
                    return {
                        error: "Poxa, algo deu errado. Tente novamente, se o problema persistir, contate o suporte",
                        status: false,
                        handled: true
                    };
            }
        }
    }

    return {
        error: "Algo deu errado. Tente novamente",
        status: false,
        handled: true
    }
}


export const ct_users = {
    async getProfile(data) {
        try {
            const { access_token } = data;

            const responseFiltered = await processRequest(
                axios.get(`${customPath('get_profile')}`,
                    {
                        headers: { Authorization: `Bearer ${access_token}` }
                    })
            );

            if (!responseFiltered.status) {
                throw responseFiltered.error
            }

            return responseFiltered.data;
        } catch (error) {
            return {
                error,
                status: false
            }
        }
    },

    async signIn({ email, password, keepLogged = false }) {
        try {
            const url = keepLogged ? `${customPath('signin')}?always_logged=true` : customPath('signin');
            const responseFiltered = await processRequest(
                axios.post(url, { email, password }, { withCredentials: true })
            );

            if (!responseFiltered.status) {
                throw responseFiltered.error
            }

            return responseFiltered;
        } catch (error) {
            return {
                error,
                status: false
            }
        }
    },

    async refreshToken() {
        try {
            const responseFiltered = await processRequest(
                axios.post(customPath('refresh'), null, { withCredentials: true })
            );

            if (!responseFiltered.status) {
                throw responseFiltered.error;
            }

            return responseFiltered;
        } catch (error) {
            return { error, status: false };
        }
    },

    async signUp(data) {
        try {
            const responseFiltered = await processRequest(
                axios.post(`${customPath('signup')}`, data)
            );


            if (!responseFiltered.status) {
                if (responseFiltered?.original?.response?.data?.message?.includes("invalid code")) {
                    throw "Código de verificação incorreto"
                }
                throw responseFiltered.error
            }

            if (responseFiltered.message.includes("check your email")) {
                responseFiltered.stage = "1/2";
                responseFiltered.message = "Um código de verificação foi enviado para o seu e-mail. Confirme para concluir o cadastro";
            } else if (responseFiltered.message.includes("verification code sent via email and whatsapp")) {
                responseFiltered.stage = "1/2";
                responseFiltered.message = "Um código de verificação foi enviado para o seu e-mail e whatsapp no número cadastrado. Confirme para concluir o cadastro";
            } else {
                responseFiltered.stage = "2/2";
                responseFiltered.message = "Conta cadastrada com sucesso. Seja bem-vindo!";
            }

            return responseFiltered;
        } catch (error) {

            return {
                error,
                status: false
            }
        }
    },

    async getWarehouseAddress(access_token, warehouse_id) {
        try {
            const responseFiltered = await processRequest(
                axios.get(customPath('get_address', `warehouse_id=${warehouse_id}`), {
                    headers: { Authorization: `Bearer ${access_token}` }
                })
            );

            if (!responseFiltered.status) {
                throw responseFiltered.error;
            }

            return responseFiltered;
        } catch (error) {
            return { error, status: false };
        }
    },

    async setWarehouseAddress(data, warehouse_id) {
        try {
            const { access_token, ...address } = data;

            const responseFiltered = await processRequest(
                axios.post(customPath('set_address', `warehouse_id=${warehouse_id}`),
                    address,
                    {
                        headers: { Authorization: `Bearer ${access_token}` }
                    })
            );

            if (!responseFiltered.status) {
                throw responseFiltered.error;
            }

            return responseFiltered;
        } catch (error) {
            return { error, status: false };
        }
    },

    async setNewAddress(data) {
        try {
            const { access_token, ...address } = data;

            const responseFiltered = await processRequest(
                axios.post(`${customPath('set_address')}`,
                    address,
                    {
                        headers: { Authorization: `Bearer ${access_token}` }
                    })
            );

            if (!responseFiltered.status) {
                throw responseFiltered.error
            }

            return responseFiltered;
        } catch (error) {
            return {
                error,
                status: false
            }
        }
    },

    async updateProfile(data) {
        try {
            const { access_token, ...profile } = data;
            const responseFiltered = await processRequest(
                axios.put(customPath('profile'), profile, {
                    headers: { Authorization: `Bearer ${access_token}` }
                })
            );
            if (!responseFiltered.status) throw responseFiltered.error;
            return responseFiltered;
        } catch (error) {
            return { error, status: false };
        }
    },

    async recoveryPw(data) {
        try {
            const { token: payload_hash, password, email } = data;

            const body = [payload_hash, password].every(Boolean)
                ? { payload_hash, password }
                : {};

            const responseFiltered = await processRequest(
                axios.post(
                    customPath(`forgot_password/${email}`),
                    body
                )
            );
            if (!responseFiltered.status) {
                throw responseFiltered.error
            }

            return responseFiltered;
        } catch (error) {
            return {
                error,
                status: false
            }
        }
    }
}